import { render } from "./documents.vue?vue&type=template&id=1fbd4f57&scoped=true"
import script from "./documents.vue?vue&type=script&lang=ts"
export * from "./documents.vue?vue&type=script&lang=ts"

import "./documents.vue?vue&type=style&index=0&id=1fbd4f57&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1fbd4f57"

export default script